var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.667 7.333h3.2c.746 0 1.12 0 1.405.146.25.127.455.331.583.582.145.286.145.659.145 1.406V14m-5.333 0V4.133c0-.746 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583C7.653 2 7.28 2 6.533 2h-2.4c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C2 3.013 2 3.387 2 4.133V14m12.667 0H1.333m3-9.333h2m-2 2.666h2m-2 2.667h2"
  })));
};
export default SvgBuilding;